const QTY_MIN = 1;

/**
 * Parse the quantity field. Empty / non-numeric → null (do not write NaN to the store).
 * Numeric values are floored at 1.
 */
export function parseQtyInput(raw: string): number | null {
    const parsed = parseInt(raw, 10);
    if (raw === '' || !Number.isFinite(parsed)) {
        return null;
    }
    return Math.max(QTY_MIN, parsed);
}

/** Qty to show when the field is not being edited. Never NaN or below 1. */
export function displayQty(storeQty: number): number {
    if (!Number.isFinite(storeQty) || storeQty < QTY_MIN) {
        return QTY_MIN;
    }
    return storeQty;
}
